import routes from "./router/routes"

export function chartingModule({ router }) {
  for (const route of routes) router.addRoute("dashboard", route)
}
